import React from "react";

const Yarn = () => {
  return <div>Yarn</div>;
};

export default Yarn;
